// Dashboard.js
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import EmployeeList from "./EmployeeList";
import axios from "axios";
import Calendar from "./Calendar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
function Dashboard() {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 2;
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [attendanceData1, setAttendanceData] = useState({});
  const [activeSection, setActiveSection] = useState("dashboard");
  const navigate = useNavigate();
  const [totalemployee, settotalemployee] = useState({
    total_employees: 0,
    total_present: 0,
    total_absent: 0,
    total_late: 0,
    total_leave: 0,
  });
  const [currentEmployeelist, setcurrentemployeelist] = useState([]);
  
  // const toggleSidebar = () => {
  //   setSidebarVisible(!sidebarVisible);
  // };
  const [currentDate, setCurrentDate] = useState(new Date());
  const nextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
    );
  };

  const prevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
    );
  };
  

  useEffect(() => {
    const apiData = [
      { date: "2025-06-15", status: "present" },
      { date: "2025-06-16", status: "absent" },
      { date: "2025-06-17", status: "leave" },
    ];
    const map = {};
    apiData.forEach((item) => {
      map[item.date] = item.status;
    });
    setAttendanceData(map);
    fetchemploylist();
  }, []);

  const fetchemploylist = async () => {
    try {
      const response = await axios.get(
        "https://ims-attendanceback.indevconsultancy.in/api/admin-dashboard"
      );
      const totalEmployees = response.data.total_employees;
      if (
        typeof totalEmployees === "number" ||
        typeof totalEmployees === "string"
      ) {
        settotalemployee({
          total_employees: totalEmployees,
          total_present: response.data.total_prensent_employees,
          total_absent: response.data.total_absent_employees,
          total_late: response.data.total_late,
          total_leave: response.data.total_leave,
        });
        setcurrentemployeelist(response.data.latest_employees_data);
      }
    } catch (error) {
      console.log("Error fetching employee list:", error);
    }
  };

  const formatDateTime = (str) => {
    if (!str) return "-";
    const date = new Date(str);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const time = date.toLocaleTimeString("en-GB");
    return `${day}-${month}-${year} ${time}`;
  };

  const attendanceData = currentEmployeelist.map((emp) => ({
    name: emp.emp_name,
    date: emp.joining_date || "N/A",
    code: emp.emp_code || "N/A",
    in: formatDateTime(emp.entry_time) || "-",
    out: formatDateTime(emp.exit_time) || "-",
    in_image: emp.entryimage || "https://via.placeholder.com/50",
    out_image: emp.exitimage || "https://via.placeholder.com/50",
  }));

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = attendanceData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(attendanceData.length / itemsPerPage);
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const [showModal, setShowModal] = useState(false);
  const [showModalcalender, setShowModalcaleder] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const handleImageClick = (src) => {
    setSelectedImage(src);
    setShowModal(true);
  };
  const handlClickCalendar = () => setShowModalcaleder(true);
  const closeModal = () => {
    setShowModal(false);
    setShowModalcaleder(false);
    setSelectedImage("");
  };
 
  const cards = [
    {
      title: "Total Employee",
      count: totalemployee.total_employees || 0,
      gradient: "linear-gradient(90deg, #0277bd, #039be5)",
      icon: "https://img.icons8.com/ios-filled/50/ffffff/conference.png",
      redirect:"employeeList",
    },
    {
      title: "Today Present",
      count: totalemployee.total_present || 0,
      gradient: "linear-gradient(90deg, #4caf50, #66bb6a)",
      icon: "https://img.icons8.com/ios-filled/50/ffffff/checked-user-male.png",
      redirect:"employeeList",
    },
    {
      title: "Today Absent",
      count: totalemployee.total_absent || 0,
      gradient: "linear-gradient(90deg, #c2185b, #e91e63)",
      icon: "https://img.icons8.com/ios-filled/50/ffffff/remove-user-male.png",
      redirect:"employeeList",
    },
    // {
    //   title: "Came Late",
    //   count: 5,
    //   gradient: "linear-gradient(90deg, #ff8f00, #ffa726)",
    //   icon: "https://img.icons8.com/ios-filled/50/ffffff/alarm-clock.png",
    // },
  ];

  return (
    <div className="container-fluid p-0 m-0">
      <div
        className="d-flex flex-column flex-md-row"
        style={{ minHeight: "100vh" }}
      >
        <div className="flex-grow-1 bg-cream">
          <div className="px-3 px-md-4 py-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex align-items-center gap-2">
                <h2 className="mb-0">
                  {activeSection === "dashboard" && "Dashboard"}
                  {activeSection === "employee" && "Employee List"}
                  {activeSection === "attendance" && "Attendance"}
                </h2>
              </div>
            </div>

            {activeSection === "dashboard" && (
              <>
                <div className="row g-4 mb-4">
                  {cards.map((card, i) => (
                    <div className="col-12 col-sm-6 col-lg-4" key={i}>
                      <div
                        className="card text-white"
                        style={{ background: card.gradient, border: "none" }}
                      >
                         <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault(); // ✅ Prevent full page reload
                              navigate(`/${card.redirect}`); // ✅ Navigate via React Router
                            }}
                            style={{ textDecoration: 'none', color: 'inherit' }} // optional: remove link styling
                          >
                            <div className="card-body d-flex justify-content-between align-items-center">
                              <div>
                                <h5>{card.title}</h5>
                                <h2>{card.count}</h2>
                              </div>
                              <img src={card.icon} alt={card.title} width="50" />
                            </div>
                          </a>
                      </div>
                    </div>
                  ))}
                </div>

                {/* table jsx dont remove because it is used later  */}
                {/* <div className="card shadow-sm">
                  <div className="card-header bg-skyBlue text-white border-bottom">
                    <h5 className="mb-0">Recent Attendance</h5>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-striped table-bordered text-center">
                        <thead className="table-light">
                          <tr>
                            <th>Sl.No.</th>
                            <th>Employee</th>
                            <th>Employee Code</th>
                            <th>Date</th>
                            <th>Check In</th>
                            <th>Check Out</th>
                            <th>In Image</th>
                            <th>Out Image</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.map((row, index) => (
                            <tr key={index}>
                              <td>{indexOfFirstItem + index + 1}</td>
                              <td>{row.name}</td>
                              <td>{row.code}</td>
                              <td>{row.date}</td>
                              <td>{row.in}</td>
                              <td>{row.out}</td>
                              <td>
                                <img
                                  src={row.in_image}
                                  alt="in"
                                  width="50"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleImageClick(row.in_image)}
                                />
                              </td>
                              <td>
                                <img
                                  src={row.out_image}
                                  alt="out"
                                  width="50"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleImageClick(row.out_image)
                                  }
                                />
                              </td>
                              <td>
                                <button
                                  className="btn btn-primary"
                                  onClick={handlClickCalendar}
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <nav className="mt-3">
                      <ul className="pagination justify-content-center">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                          >
                            Previous
                          </button>
                        </li>
                        {[...Array(totalPages)].map((_, i) => (
                          <li
                            className={`page-item ${
                              currentPage === i + 1 ? "active" : ""
                            }`}
                            key={i}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(i + 1)}
                            >
                              {i + 1}
                            </button>
                          </li>
                        ))}
                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div className="card-footer text-muted text-center small">
                    Technology Partner: Indev Consultancy ©2025
                  </div>
                </div> */}

                <div className="card shadow border-0">
                  <div className="card-header bg-skyBlue text-white d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                    <h5 className="mb-2 mb-md-0">
                      <i className="bi bi-calendar3 me-2"></i> Attendance
                      Calendar
                    </h5>
                    <div className="d-flex gap-2 flex-wrap justify-content-center justify-content-md-end calendar-nav-buttons">
                      <button
                        onClick={prevMonth}
                        className="btn btn-nav px-3 py-1 text-white"
                      >
                        <FontAwesomeIcon icon={faArrowLeft} /> Prev
                      </button>
                      <button
                        onClick={nextMonth}
                        className="btn btn-nav px-3 py-1 text-white"
                      >
                        Next <FontAwesomeIcon icon={faArrowRight} /> 
                      </button>
                    </div>
                  </div>
                  <div className="card-body p-3">
                    <div className="calendar-wrapper mx-auto">
                      <Calendar
                        date={currentDate}
                        attendance={attendanceData1}
                        onDateSelect={(date) => {
                          setSelectedDate(date);
                          // Route pe le jao
                          navigate(`/employee-attendance/${date.toISOString().split("T")[0]}/0`);
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="card shadow border-0">
                  <div className="card-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center bg-skyBlue text-white">
                    <h5 className="mb-2 mb-md-0">📅 Attendance Calendar</h5>
                    <div className="d-flex gap-2">
                      <button
                        onClick={prevMonth}
                        className="btn btn-outline-light btn-sm px-3"
                        title="Previous Month"
                      >
                        ⬅ Prev
                      </button>
                      <button
                        onClick={nextMonth}
                        className="btn btn-outline-light btn-sm px-3"
                        title="Next Month"
                      >
                        Next ➡
                      </button>
                    </div>
                  </div>

                  <div className="card-body p-3">
                    <div className="row justify-content-center">
                      <div className="col-12 col-md-10 col-lg-8">
                        <Calendar
                          date={currentDate}
                          attendance={attendanceData1}
                          onDateSelect={(date) => setSelectedDate(date)}
                        />
                      </div>
                    </div>
                  </div>
                </div> */}
              </>
            )}

            {activeSection === "employee" && <EmployeeList />}
            {activeSection === "attendance" && (
              <h4>Attendance Calendar will be shown here.</h4>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal show d-block" tabIndex="-1" onClick={closeModal}>
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Image Preview</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body text-center">
                <img src={selectedImage} alt="Preview" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      )}

      {showModalcalender && (
        <div className="modal show d-block" tabIndex="-1" onClick={closeModal}>
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Report</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body text-center">
                <button onClick={prevMonth}>⬅ Prev</button>
                <button onClick={nextMonth}>Next ➡</button>
                <Calendar date={currentDate} attendance={attendanceData23} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
